import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {RouterService} from '../services/router.service';

export const legacyModuleRedirectGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const routerService = inject(RouterService);

  // Get the target URL from the current navigation
  const navigation = router.getCurrentNavigation();
  let targetUrl = navigation?.finalUrl?.toString() ?? navigation?.extractedUrl.toString() ?? '';

  // Fallback: build path from route if navigation is not available
  if (!targetUrl) {
    // Build the full path from the route tree (from root down)
    const pathFromRoot = route.pathFromRoot
      .filter(r => r.url.length > 0)
      .map(r => r.url.map(segment => segment.path).join('/'))
      .join('/');

    targetUrl = '/' + pathFromRoot;

    // Add query parameters if present
    const queryParams = route.queryParams;
    if (Object.keys(queryParams).length > 0) {
      targetUrl += '?' + Object.keys(queryParams)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`)
        .join('&');
    }

    // Add fragment if present
    if (route.fragment) {
      targetUrl += '#' + route.fragment;
    }
  }

  routerService.openLegacyRoute(targetUrl, '_blank');

  // Navigate to home to prevent showing an error page
  router.navigate(['/home']);

  // Prevent Angular from activating this route
  return false;
};
